module.exports = __webpack_public_path__ + "images/檀程长图_06-3.jpg?v=d3b3f1ae";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图_06-3.jpg
 ** module id = 193
 ** module chunks = 1 2
 **/